export const API=process.env.REACT_APP_BACKEND || "http://localhost:5000/"
